export default class {
    constructor ($window, $rootScope, $translate, $state, ModalService) {
        this.ModalService = ModalService;
        this.confirm = false;
        // custom message is supported only when angular location changes but we try our best because some browser might allow it
        this.message = $translate.instant('general.On page refresh all unsaved data will be lost. Are you sure you wish to continue?');

        $window.onbeforeunload = () => {
            return this.confirm ? this.message : undefined;
        };

        // currently commented out because state change confirm should be used with data dirty detection
        // $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
        //     if (this.confirm) {
        //         event.preventDefault();
        //         ModalService.confirm(this.message)
        //             .then(() => $state.go(toState.name, toParams))
        //             .catch(() => event.preventDefault());
        //     }
        // });

        // we do not want it to carry over to other views
        $rootScope.$on('$stateChangeSuccess', () => this.deactivate());
    }

    activate () {
        this.confirm = true;
    }

    deactivate () {
        this.confirm = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/window/confirm/index.js